import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Checkbox';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AuthContext  from './auth/Context';
class CustSwitch extends React.PureComponent{
    constructor(props){
        super(props);
        this.state={
            value:this.convertValue(this.props.value),
            disabled:this.props.disabled,
            readOnly:this.props.readOnly,
            clearComponent:false
        }
        this.handleValueChanged = this.handleValueChanged.bind(this);
    }
    componentDidUpdate(oldProps){
        if(oldProps.value!==this.props.value || oldProps.disabled!==this.props.disabled  || oldProps.readOnly!==this.props.readOnly){
        this.setState({clearComponent:true},()=>{
            this.setState({
                clearComponent:false,
                value:this.convertValue(this.props.value),
                disabled:this.props.disabled,
                readOnly:this.props.readOnly,
            })
        })
        }
    }
    convertValue(v){
        if(v=="false" || v==0) return false;
        if(v=="true" || v==1) return true;
        return v;
    }
    handleValueChanged(event){
        if(this.state.readOnly || this.state.disabled) return;
        if(this.props.onChange){
            this.props.onChange(event);
        }
    }
    render(){
        if(this.state.clearComponent) return null;
        let readOnly = this.state.readOnly || this.state.disabled;
        if(!this.props.label){
            return <Switch disabled={readOnly} color={this.props.color||'primary'} size={this.props.size} checkedIcon={<CheckBoxIcon  />} InputProps={{readOnly: this.state.readOnly}}  checked={this.state.value} onChange={this.handleValueChanged} />
        }
        return (
            <FormControlLabel 
                control={<Switch disabled={readOnly} color={this.props.color||'primary'}  size={this.props.size} checkedIcon={<CheckBoxIcon  />} InputProps={{readOnly: this.state.readOnly}} checked={this.state.value} onChange={this.handleValueChanged} />}
                label={<Typography noWrap>{this.props.label}</Typography>}
            />
        )
    }
}
CustSwitch.contextType = AuthContext;
CustSwitch.propTypes={
    label: PropTypes.string,
    value: PropTypes.bool,
    size:PropTypes.any,
    disabled:PropTypes.bool,
    readOnly:PropTypes.bool,
    onChange:PropTypes.func

}
export default CustSwitch
